import script from "./contract-list.vue?vue&type=script&lang=tsx&setup=true"
export * from "./contract-list.vue?vue&type=script&lang=tsx&setup=true"

import "./contract-list.vue?vue&type=style&index=0&id=58d4b22c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58d4b22c"]])

export default __exports__